module.exports = __webpack_public_path__ + "static/media/flag.75bae357.svg";